import './ContactPopup.css';
import React, { useEffect } from "react";

const ContactPopup = ({ isOpen, onClose }) => {

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="contact-popup-overlay" onClick={onClose}>
      <div className="contact-popup" onClick={e => e.stopPropagation()}>

        <div className="contact-header">
          <h2 className="contact-title">Contact</h2>
          <button className="contact-close-btn" onClick={onClose} aria-label="Fermer">✕</button>
        </div>

        <div className="contact-content">
          <div className="info-section">
            <div className="info-item">
              <span className="info-label">Identité</span>
              <span className="info-value"><strong>Elise VOËT</strong></span>
            </div>
            <div className="info-item">
              <span className="info-label">Pronoms</span>
              <span className="info-value">elle / elle</span>
            </div>
            <div className="info-item">
              <span className="info-label">Langues</span>
              <span className="info-value">bilingue français / anglais</span>
            </div>
            <div className="info-item">
              <span className="info-label">Localisation</span>
              <span className="info-value">Vit et travaille à Mer et Orléans</span>
            </div>
            <div className="info-item">
              <span className="info-label">Instagram</span>
              <span className="info-value">
                <a href="https://www.instagram.com/_elise_voet_/" target="_blank"
                  rel="noreferrer" className="contact-link">
                  @_elise_voet_
                </a>
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Email</span>
              <span className="info-value">
                <a href="mailto:elise.voet@hotmail.fr" className="contact-link">
                  elise.voet@hotmail.fr
                </a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPopup;